import React, { useEffect, useState, useContext } from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'

import DenseTable from './Table'
import DetailModal from './Modal'
import { getProgressCandidate, getPendingCandidate } from '../../Assets/Interfaces/CandidatesInterface'
import { GlobalContext } from '../../store'

const InfoCalculation = () => {
    const [state] = useContext(GlobalContext)
    const [runningCalculation, setRunningCalculation] = useState({
        pending: 0,
        progress: 0,
    })
    const [progress, setProgress] = useState([])

    const [openDetailProgress, setOpenDetailProgress] = useState(false)
    const handleOpenDetailProgress = () => {
        progress.length > 0 && setOpenDetailProgress(true)
    }
    const handleCloseDetailProgress = () => setOpenDetailProgress(false)

    useEffect(() => {
        if (state.socket) state.socket.on('calculation-info', (dataSocket) => setRunningCalculation(dataSocket))
    }, [state.socket])

    useEffect(() => {
        if (runningCalculation.pending || runningCalculation.progress) {
            runningCalculation.progress && getProgressCandidate().then((res) => setProgress(res))
        }
        runningCalculation.progress === 0 && setProgress([])
    }, [runningCalculation.pending, runningCalculation.progress])

    return (
        <>

            <DetailModal
                title='Calculation in progress'
                open={openDetailProgress}
                rows={progress}
                handleClose={handleCloseDetailProgress}
            />
            <div>
                <ButtonGroup disableElevation variant='text' size='large' color='inherit'>
                    <Button color='inherit'>
                            <div>
                                Pending: <b>{runningCalculation.pending}</b>
                            </div>
                    </Button>
                    <Button color='inherit'>
                        <Tooltip
                            onClick={handleOpenDetailProgress}
                            title={progress.length > 0 ? <DenseTable rows={progress} resume={5} /> : <></>}>
                            <div>
                                Progress: <b>{runningCalculation.progress}</b>
                            </div>
                        </Tooltip>
                    </Button>
                </ButtonGroup>
            </div>
        </>
    )
}

export default InfoCalculation
